import { Component, OnInit } from '@angular/core';
import { PermissionsService } from '../../../../services/Permissions';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Apiservice } from '../../../../services/ApiService';
import { VenueService } from '../../../../services/VenueService';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.scss'
})
export class EditUserComponent implements OnInit {
  userID: string = '';
  email: string = '';
  ticketmaster;
  venueAdmin: boolean = false;
  Selectedvenue: string = '';
  venuelist: any[] = [];
  editVenueAdmin: boolean = false;
  venues: any[] = [];
  userVenues: any[] = [];
  editUserVenues: any[] = [];
  loading: boolean = false;
  firstname: string = '';
  lastname: string = '';
  phonenumber: string = '';
  primaryVenue: string = '';

  constructor(private permissions: PermissionsService,private router: Router,private _http:HttpClient, private apiservice: Apiservice,public venue: VenueService) {
    this.ticketmaster = this.permissions.ticketmaster;
    this.permissions.venueAdmin.subscribe((isAdmin: boolean) => {
      this.venueAdmin = isAdmin;});
   }


  ngOnInit(): void {
      this.permissions.checkPermissions();
      if(this.venueAdmin){
      this.Selectedvenue = history.state.primaryVenueText
      this.primaryVenue = history.state.primaryVenue
      this.getVenueList();
      this.userID = history.state.user;
      this.email = history.state.email;
      this.venueAdmin = history.state.venueAdmin;
      this.userVenues = history.state.venues ?? [];
      // Seed venues with the user's existing assignments so saving preserves
      // them. Copy (spread) to avoid mutating the navigation history state.
      this.venues = [...this.userVenues];
      }
      else{
        this.router.navigate(['/attendance']);
      }
  }

  onEmailChange(event: any){

  }

  onVenueAdminChange(event: any){
    if(event.target.checked) {
      this.venueAdmin = true;
    }
      else{
        this.venueAdmin = false;
      }
  }

  onPrimaryVenueChange(event: any){
    this.primaryVenue = event.target.value
  }

  toggleAdminCheckbox(){
    if (this.venueAdmin === true){
      return true; 
    }
    else{
      return false;
    }
  }

  selectVenueChangeHandler(event: any, item: any){
    if(event.target.checked)
      {
         this.venues.push(item.key);
    
         if(item.key == 'ticketmaster'){
          this.venues.push('all')
         }
      }
      else{
        const index = this.venues.indexOf(item.key);
        this.venues.splice(index, 1);
      }
    }

  toggleVenueCheckBox(item: any){
    return this.userVenues.includes(item.key);
  }

  editUser(){
    const body ={
      email: this.email,
      firstName: this.firstname,
      lastName: this.lastname,
      phonenumber: this.phonenumber,
      venues: this.venues,
      primaryVenue: this.primaryVenue,
      venueAdmin: this.venueAdmin }
    this._http.post('https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/user', body).subscribe({
      next: data => {

      },
  
      error: error => {
  

      },
      complete: () => {
        this.router.navigate(['/users/search']);
      }
  })
  
  }

  getVenueList(){
    this.loading = true;
    this.venue.getVenueList().subscribe((data:any) => {
      this.venuelist = data;
      this.loading = false;
    });
  }



}
